import React from 'react'
import { Table } from 'antd'
import { observer } from 'mobx-react-lite'
import { ReportsStore } from 'store/reports.store'
import { columns } from './referrers-columns'
import './styles.scss'

export const ReferrersReportFeature = observer(() => (
  <Table
    columns={columns}
    dataSource={ReportsStore.referrerReport}
    pagination={false}
  />
))
